module.exports = __webpack_public_path__ + "img/huxianquan5.prt.0cef46b1.jpg";